import React, { useEffect } from 'react';

interface DynamicMapStylesProps {
  primaryColor: string;
}

function DynamicMapStyles({ primaryColor }: DynamicMapStylesProps) {
  useEffect(() => {
    // Remove existing dynamic styles
    const existingStyle = document.getElementById('dynamic-map-styles');
    if (existingStyle) {
      existingStyle.remove();
    }

    // Create new dynamic styles
    const style = document.createElement('style');
    style.id = 'dynamic-map-styles';
    style.innerHTML = `
      /* Dynamic brand color zoom controls */
      .leaflet-control-zoom a {
        background: white !important;
        border: none !important;
        color: ${primaryColor} !important;
        font-weight: bold !important;
        font-size: 18px !important;
        line-height: 26px !important;
        transition: all 0.2s ease !important;
      }

      .leaflet-control-zoom a:hover {
        background: ${primaryColor}10 !important;
        color: ${primaryColor} !important;
        transform: scale(1.05) !important;
      }

      .leaflet-control-zoom {
        box-shadow: 0 4px 12px ${primaryColor}20, 0.8px 0.8px 5px 0px hsl(0, 0%, 0%, 0.14) !important;
      }
    `;
    
    document.head.appendChild(style);

    // Cleanup on unmount
    return () => {
      const styleElement = document.getElementById('dynamic-map-styles');
      if (styleElement) {
        styleElement.remove();
      }
    };
  }, [primaryColor]);

  return null;
}

export default DynamicMapStyles;